<template>
    <v-container class="">
      <SelectAgentWidget v-if="currentAgency"
                         :agency="currentAgency"
                         v-model="selectedAgentIds"
                         :quickAgents="quickAgents"
                         editable
                         @update:quickAgents="quickAgents = $event"
                         @confirm="confirmSelection"
                         @cancel="closePanel"
                         @select-all="selectAll"
                         @unselect-all="unselectAll"
      />
    </v-container>
</template>


<script>
import { get } from "@/utils/api";
import FormMixin from "@/components/mixins/FormMixin";
import SelectAgentWidget from "@/components/commons/SelectAgentWidget.vue";

export default {
  name: "SelectAgentPanel",
  mixins: [FormMixin],
  components: { SelectAgentWidget },
  props: {
    open: { type: Boolean, default: false },
    agencyId: { type: Number, default: null },
    agentId:  { type: [Number, null], default: null },
    initialSelection: { type: Object, default: null },
  },
  emits: ["select", "close"],
  data: () => ({
    selectedAgentIds: [],
    quickAgents: [],
    fetchData: {
      loading: false,
      agency: null,
    }
  }),
  created() {
    this.init()
  },
  watch: {},
  computed: {
    currentAgency() {
      return this.fetchData.agency || this.initialSelection?.agency || null
    }
  },
  methods: {
    init() {
      this.selectedAgentIds = [...(this.initialSelection?.selectedIds || [])]
      this.quickAgents = [...(this.initialSelection?.quickAgents || [])]

      const initialAgency = this.initialSelection?.agency || null
      const hasLoadedAgents = Array.isArray(initialAgency?.agents)

      if (initialAgency && hasLoadedAgents) {
        this.fetchData.agency = initialAgency
        return
      }

      const agencyId = initialAgency?.id || this.agencyId
      if (!agencyId) { return }

      this.fetchData.loading = true
      const url = `/api/workshop/agency/${agencyId}`

      get(url).json((result) => {
        this.fetchData.agency = result

        if (this.agentId && !this.selectedAgentIds.includes(this.agentId)) {
          this.selectedAgentIds = [...this.selectedAgentIds, this.agentId]
        }
      }).finally(() => {
        this.fetchData.loading = false
      })
    },
    confirmSelection(clearSearch = true) {
      this.$emit("select", {
        agency: this.currentAgency,
        selectedIds: this.selectedAgentIds,
        quickAgents: this.quickAgents
      }, clearSearch)
    },
    closePanel() {
      this.$emit("close")
    },
    selectAll() {
      const agents = this.currentAgency?.agents || []
      const allIds = new Set(agents.map(a => a.id))
      this.selectedAgentIds = [...allIds]
    },
    unselectAll() {
      this.selectedAgentIds = []
    }
  }
}
</script>


<style scoped>
</style>